import { label, STATUS_STYLES, SEVERITY_STYLES } from "@/lib/constants";
import { cn } from "@/lib/utils";

export const StatusBadge = ({ value, testId }) => (
  <span
    data-testid={testId}
    className={cn(
      "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium",
      STATUS_STYLES[value] || "bg-slate-100 text-slate-700 border-slate-200"
    )}
  >
    {label(value)}
  </span>
);

export const SeverityBadge = ({ value, testId }) => (
  <span
    data-testid={testId}
    className={cn(
      "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium",
      SEVERITY_STYLES[value] || SEVERITY_STYLES.low
    )}
  >
    {label(value)}
  </span>
);
